<template>
 <div class="price-partner ">
  <div v-for="(item, index) in dataList" :key="index" class="price-partner-content-item price_box">
   <img :src="getImgUrl(item)" alt="" style=" margin-bottom: 5px;">
   <span>{{ item.input988275a1 }}</span>
  </div>
 </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { getFilterList } from "@/api/index"
import ScrollReveal from 'scrollreveal'
const dataList = ref([])



const getImgUrl = (item) => {
 if (item['picture-uploada0bd83ed'] && item['picture-uploada0bd83ed'].length > 0) {
  return item['picture-uploada0bd83ed'][0].url
 } else {
  return ""

 }
}

const getTitle = (props) => {
 let info = dataList.value[props.i]
 if (info) {
  return info['input988275a1']
 } else {
  return ""
 }
}
const getData = async () => {
 let params = {
  page: 1,
  pageSize: 10000,
  sortField: "number4d19687a",
  isAsc: false,
  worksheetId: "681abcab515de26d772617d5",
 }
 const res = await getFilterList(params)
 if (res.code === 200 && res.data && res.data.length > 0) {
  dataList.value = res.data
 }
}

onMounted(async () => {
 await getData()
 const sr = ScrollReveal({
  distance: '50px',
  duration: 1000,
  delay: 300,
 })

 // 为每个元素配置不同的动画
 sr.reveal(".price_box", {
  beforeReveal: (el) => {
   el.classList.add('animate__fadeInUp')
  },
 })
})
</script>

<style scoped lang="less">
@media screen and (max-width: 800px) {
 .price-partner {
  padding: 10px !important;
  // grid-template-columns: repeat(auto-fill, 140px) !important;
  display: flex !important;
  flex-wrap: wrap !important;
  justify-content: space-around !important;


 }

 .price-partner-content-item {
  width: 28rem !important;
  margin: 10px 0 !important;
 }

}



@media screen and (min-width: 800px) {
 .price-partner {
  padding-left: 18%;
  padding-right: 18%;
  grid-template-columns: repeat(auto-fill, 160px) !important;
  display: grid !important;

 }

 .price-partner-content-item {
  width: 160px !important;

 }

}

.price-partner {
 width: 100%;
 overflow: auto;
 padding-left: 18%;
 padding-right: 18%;
 padding-top: 50px;
 // display: flex;
 // align-items: center;
 // justify-content: space-between;
 // flex-wrap: wrap;
 display: grid;
 justify-content: space-between;
 grid-template-columns: repeat(auto-fill, 160px);
 grid-gap: 10px;
 padding-bottom: 50px;
}

.price-partner-content-item {
 width: 160px;
 height: 93px;
 margin: 10px 10px;
 display: flex;
 flex-direction: column;
 justify-content: center;
 align-items: center;
 background: #FFFFFF;
 flex-shrink: 0;
 box-shadow: 0px 1px 5px 0px rgba(185, 196, 218, .4);
 border-radius: 4px;
}

// .price-partner::after {
//  content: '';
//  flex: 1;
//  /* 或者flex: 1 */
// }</style>